import useMetaTags from '../../hooks/useMetaTags';
import { BenefitSection, LargeData, roleWriting, sectionData, AssistanceSection, FAQ } from '../../Data/All_Services_Data/wooCommerceDevelopmentData';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Handle_Largedata_section from '../../component/Services_Component/Handle_Largedata_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import BulletsSection from '../../component/Services_Component/BulletsSection';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const WooCommerceDevelopment   = () => {
  useMetaTags({
    title:
      "Custom WooCommerce Development Services for Your Unique Business",
    description:
      "Warrgyizmorsch offers custom WooCommerce development tailored to your business. Get scalable, secure, and high-performing online stores that boost your growth.",
    keywords:
      "woocommerce development services, woocommerce development company, woocommerce development, woocommerce web design, woocommerce developer, woocommerce development agency, woocommerce website development, woocommerce expert, woocommerce website developer, woocommerce website developers, woocommerce website development services, woocommerce website development company, woocommerce web development services", });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                WooCommerce Development Customized for Your Unique Business Needs
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/e-commerce.avif"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  Warrgyizmorsch creates WooCommerce development services made exactly for what your business needs most. We never use the same method for everyone, because every online shop is built WooCommerce Development differently. No matter if you are opening a new eCommerce shop or improving the one you have now, our WooCommerce developer will deliver what blends perfectly with your brand, how you work, and your goals for the future. As a WooCommerce development company people trust, we focus on giving you flexibility, scaling your business, and designs that put users first to keep your website strong and easy to use for customers.
                </p>
              </div>
            </div>

            <Benefits_section data={BenefitSection} />

            <Handle_Largedata_section LargeData={LargeData} />

            <Role_writing data={roleWriting} />

            <BulletsSection data={sectionData} />

            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  )
}

export default WooCommerceDevelopment  